import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=b5ab2f56&scoped=true&"
import script from "./LeadDetails.vue?vue&type=script&lang=js&"
export * from "./LeadDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5ab2f56",
  null
  
)

export default component.exports